@if (date) {
  <mat-icon
    matTooltipClass="date-tooltip"
    [matTooltip]="date | date: 'dd. MMMM yyyy'">
    calendar_today
  </mat-icon>
}
